  //JS Edit, mod to set broswer language as cart attribute to save to order "additional details" and use language to pull in the order confirmation email template for language selection when sending email
  async function saveLocaleBeforeCheckout(event, form) {

    //legacy. This function still hard coded to the 'checkout now' buttons, but not in use as we are now setting cart attribute when any page on site loads for the first time.
    //return true;

    if (window.browserLocaleSaved || form.dataset.localeSaved === 'true') return;
  
    //console.log('in here.');
    // The second submit is the real checkout submission.
    if (form.dataset.localeSaved === 'true') return;
  
    event.preventDefault();
    const button = event.submitter || form.querySelector('[name="checkout"]');
    button.disabled = true;
  
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            browser_locale: navigator.language || 'en-US'
          }
        })
      });
      //return false;
      if (!response.ok) throw new Error('Cart attribute update failed');
  
      form.dataset.localeSaved = 'true';
      button.disabled = false;
      form.requestSubmit(button);
    } catch (error) {
      console.error('Could not save browser language:', error);
      button.disabled = false;
      // Stay in the cart drawer rather than placing an order without the value.
    }
  }